module.exports = "/_next/static/images/wrench-line-71b959481d1c94e07c2fc203d4aa347a.svg";